import React, { useContext } from 'react';
import NostoProduct from './Product';
import ProductVariationContext from '../ProductVariationProvider/ProductVariationContext';
import ChannelContext from '../ChannelContext';
import get from 'lodash.get';
const FlightNostoProduct = () => {
    const { selectedVariation, product } = useContext(ProductVariationContext);
    const { selectedChannel } = useContext(ChannelContext);
    if (get(selectedChannel, 'settings.nostoAccountId') &&
        product &&
        product.articleNumber !== '') {
        const imageUrl = get(product, 'images[0].url') || get(product, 'images[0].sizes[0].url');
        const currentProduct = selectedVariation || product;
        const data = {
            productId: product.id.toString(),
            name: product.name,
            url: `${selectedChannel.url}${product.primaryRoute.path}?channelCountry=${selectedChannel.country.code}`,
            imageUrl,
            availability: get(currentProduct, 'stockStatus.buyable')
                ? 'InStock'
                : 'OutOfStock',
            price: get(currentProduct, 'price.incVat'),
            currencyCode: selectedChannel.currency.format.code,
            categories: product.categories.map(category => category.primaryRoute.path),
            description: product.description
        };
        return React.createElement(NostoProduct, { data: data, promise: null, elementClicked: null });
    }
    else
        return null;
};
export default FlightNostoProduct;
//# sourceMappingURL=FlightNostoProduct.js.map